module.exports = __webpack_public_path__ + "static/img/3.ff664f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/questionnaire/3.png
// module id = tdHY
// module chunks = 1